import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, h, reactive } from 'vue';
import { NTree } from 'naive-ui';
import Nav from './nav.vue';
import usePreference from '@teams/common/hooks/usePreference';
import Icon from '@teams/common/components/icon';
export default /*#__PURE__*/_defineComponent({
  __name: 'treeNav',
  props: {
    isDragging: {
      type: Boolean
    }
  },
  emits: ["add:subNav"],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const preference = usePreference(); // 默认方型

    const type = computed( // eslint-disable-next-line @typescript-eslint/no-explicit-any
    () => preference.current.theme.styles['PC-nav-style-type'] ?? 'card');
    const isUnderline = computed(() => type.value === 'line'); // 下划线

    const isRound = computed(() => type.value === 'capsule'); // 胶囊

    const isRectangle = computed(() => type.value === 'card'); // 方型

    function renderLabel(params) {
      const {
        option
      } = params;
      const {
        name,
        icon,
        disabled,
        customStyles
      } = option;
      return h(Nav, reactive({
        isDragging: props.isDragging,
        name,
        icon,
        disabled,
        customStyles,

        onAddSubNav(e) {
          e.stopPropagation();
          emit('add:subNav', option);
        }

      }));
    }

    function renderSwitcherIcon() {
      return h(Icon, {
        name: 'transverseTriangle',
        size: 20
      });
    }

    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(NTree), _mergeProps({
        class: ['tree-nav__container', {
          'tree-nav__underline': _unref(isUnderline),
          'tree-nav__round': _unref(isRound),
          'tree-nav__rectangle': _unref(isRectangle)
        }]
      }, _ctx.$attrs, {
        "block-line": "",
        "render-label": renderLabel,
        "render-switcher-icon": renderSwitcherIcon
      }), null, 16, ["class"]);
    };
  }

});